import React from 'react';
import PropTypes from 'prop-types';

import { PaymentMethodInfo } from 'components';
import { COMMON_ICON } from 'constant/paymentConstants';
import { getAssetsPath } from 'getters/paymentGetters/paymentGetters';
import { StyledImg } from '../PaymentMethodInfo/PaymentMethodInfo.styled';

/**
 * PaymentMethodDetails component.
 *
 * @property {boolean} isPaymentMethodCapabilityEnabled - Indicates if the payment method capability is enabled.
 * @property paymentMethod - The payment method object containing details to display.
 */
const PaymentMethodDetails = ({
  isPaymentMethodCapabilityEnabled,
  paymentMethod,
}) => {
  /**
   * If the payment method capability is enabled, render the PaymentMethodInfo component.
   * Otherwise, render a common icon.
   */
  if (isPaymentMethodCapabilityEnabled) {
    return <PaymentMethodInfo paymentMethod={paymentMethod} />;
  }
  return (
    <StyledImg
      alt="card-icon"
      data-testid="BillingLicensing-PaymentMethodDetails-CommonIcon"
      src={getAssetsPath(COMMON_ICON)}
    />
  );
};

PaymentMethodDetails.propTypes = {
  isPaymentMethodCapabilityEnabled: PropTypes.bool.isRequired,
  paymentMethod: PropTypes.object.isRequired,
};

export default PaymentMethodDetails;
